const Options = [
  {
    cardName: 'Create from <br> scratch',
    icon: 'fluent:edit-16-regular',
  },
  {
    cardName: 'Guide AI with my descriptions',
    icon: 'hugeicons:ai-chat-02',
  },
   {
    cardName: 'Make AI use my resource',
    icon: 'hugeicons:ai-mail',
  }, 
]

export default Options
